import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, IconButton, Menu, MenuItem } from '@mui/material';
import { MouseEvent, useState } from 'react';
import { ActionType } from '../../app/reducer/AppContextReducer';
import { listItemWrapper } from '../../../../shared/lib/theme/styleConstants';
import { useAppContext } from '../../app/contexts/AppContext';
import { LABEL_CHANGE_CARD } from '../../../../shared/lib/constants';

export const EditPaymentMethod = () => {
  const { dispatch } = useAppContext();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const changeCard = () => {
    dispatch({ type: ActionType.SET_IS_CHANGE_PLAN, isChangePlan: true });
    setAnchorEl(null);
  };

  return (
    <Box position="absolute" top="10px" right="10px">
      <IconButton id="basic-button" aria-controls={open ? 'basic-menu' : undefined} aria-haspopup="true" aria-expanded={open ? 'true' : undefined} onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>

      <Menu
        sx={listItemWrapper}
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
      >
        <MenuItem onClick={changeCard}>{LABEL_CHANGE_CARD}</MenuItem>
      </Menu>
    </Box>
  );
};
